/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable max-lines-per-function */
import React, { useState } from "react";
import { KeyboardDatePicker } from "@material-ui/pickers";
import { SelectAutocomplete } from "components/haven-design/form/select";
import ErrorMessage from "components/error-message";
import StructuredReasons from "components/structured-reasons";
import { Input } from "components/haven-design/form/inputs";
import { QueryInterestProfile_interest as InterestType } from "types/gql-types";
import styles from "./batchActions.module.css";

export interface ChangeStatusStateValues {
  actionDate: string | null;
  reason: string;
  status: string;
  unitNumber: string | null;
}

interface Props {
  interest: InterestType;
  onChange: (item: Partial<ChangeStatusStateValues>) => void;
  isShowing: boolean;
  errorMsg?: string;
  state: ChangeStatusStateValues;
}
const ChangeStatusForm: React.FC<Props> = ({
  interest,
  onChange,
  isShowing,
  errorMsg,
  state,
}) => {
  const statusOptions = (interest?.interestList?.property?.stages || [])
    .filter(({ enabled }) => enabled);

  const [reasonIsShowing, setReasonIsShowing] = useState(false);
  const [status, setStatus] = useState<string | undefined>();
  const [reason, setReason] = useState<string>("");

  return (
    <div className={isShowing ? "" : styles.hideView}>
      <div className={styles.actionViewLabel}>
        Change Status from &quot;{interest.status.name}&quot;
      </div>

      <ErrorMessage errorMsg={errorMsg}/>

      <SelectAutocomplete
        margin="dense"
        label="Select Outcome *"
        options={statusOptions as any[]}
        getOptionDisabled={(option: any) => option.name === interest.status.name}
        getOptionLabel={(option: any) => option.name}
        getOptionSelected={(option: any, value: string) => option.name === value}
        value={status}
        onChange={(_, newStatus: any) => {
          if (!newStatus) return;

          setStatus(newStatus.name);
          setReasonIsShowing(true);
          onChange({
            status: newStatus.name,
            reason,
            actionDate: newStatus.name === "Moved In" ? new Date().toISOString() : null,
          });
        }} />

      {status === "Moved In" && (
        <div>
          <KeyboardDatePicker
            style={{ minWidth: "15em" }}
            margin="dense"
            name="actionAt"
            autoComplete="off"
            autoOk
            variant="inline"
            inputVariant="outlined"
            label="Move In Date"
            format="MM/dd/yyyy"
            InputAdornmentProps={{ position: "end" }}
            value={state.actionDate}
            onChange={date => onChange({ actionDate: date?.toISOString() || null })}
          />

          <Input
            name="unitNumber"
            label="Unit Number"
            onChange={({ target: { value } }) => onChange({ unitNumber: value })}
          />
        </div>
      )}

      {reasonIsShowing && status !== "Moved In" && (
        <div className={styles.marginTop}>
          <p>Changing the status to <b>{status}</b> requires a reason for auditing purposes.</p>

          {status === "Removed" ? (
            <StructuredReasons
              label="Removal Reason*"
              onChange={(message) => {
                setReason(message);
                onChange({ status, reason: message, actionDate: new Date().toISOString() });
              }}
            />
          ) : (
            <div>
              <Input
                name="reason"
                label="Reason"
                multiline
                required
                onChange={({ target: { value: message } }) => {
                  setReason(message);
                  onChange({ status, reason: message, actionDate: new Date().toISOString() });
                }}
                value={reason}
              />
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default ChangeStatusForm;
